/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){

	function initEventListeners(){
        pipEvents.requestQuote.requestQuoteButtonClicked.off('.requestAQuoteClick');
		pipEvents.requestQuote.requestQuoteButtonClicked.on('.requestAQuoteClick', function(){
            var obj ={
                category:{
                    primaryCategory: 'button submission'
                },
                eventInfo: {
                    eventName: 'request a quote'
                }
            };

            if (pip.debugMode) console.log('DDO Event', obj);

            if(window.digitalData && window.digitalData.event) window.digitalData.event.push(obj);
		});
	}


	return {
		init: function(){
			initEventListeners();
		}
	}

});

}.call(window));